import React from 'react';

import { Box, Button } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import * as selectors from '../selectors';

import EmailAutocomplete from './EmailAutocomplete';

const EmailsOnlyForm = ({ callback, initialValues }) => {
    const { t } = useTranslation();
    const { control, getValues, handleSubmit, trigger } = useForm({
        mode: 'onChange',
        defaultValues: initialValues,
    });

    const handleSave = (values) => {
        callback?.(values);
    };

    return (
        <form>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <EmailAutocomplete
                    control={control}
                    name="auth_emails"
                    defaultValue={getValues('auth_emails') || []}
                    trigger={trigger}
                />
                <Box textAlign="right">
                    <Button
                        fullWidth={false}
                        onClick={handleSubmit(handleSave)}
                        sx={{
                            mb: { md: 0, xs: 2 },
                            order: { md: 2, xs: 1 },
                            width: { md: 'auto', xs: '100%' },
                        }}
                        type="button"
                        variant="outlined"
                    >
                        {t('Save')}
                    </Button>
                </Box>
            </Box>
        </form>
    );
};

EmailsOnlyForm.propTypes = {
    callback: PropTypes.func,
    initialValues: PropTypes.object,
};

const mapStateToProps = createStructuredSelector({
    initialValues: selectors.getInitialValuesAuthEmails,
});

export default connect(mapStateToProps, null)(EmailsOnlyForm);
